/* SAHICHARAN — product.js */
(function () {
  'use strict';
  var S = window.Sahicharan || (window.Sahicharan = {});

  function money(cents, format) {
    format = format || (window.Shopify && window.Shopify.money_format) || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = format
      .replace(/\{\{\s*amount\s*\}\}/, intPart + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intPart)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1]);
    return out.replace(/<[^>]+>/g, '');
  }
  S.money = money;

  function initProduct(section) {
    var form = S.qs('form[data-product-form]', section);
    if (!form) return;
    var dataEl = S.qs('[data-product-json]', section);
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = S.qs('input[name="id"]', form);
    var priceEl = S.qs('[data-price]', section);
    var compareEl = S.qs('[data-compare-price]', section);
    var saleBadge = S.qs('[data-sale-badge]', section);
    var addBtn = S.qs('[data-add-to-cart]', form);
    var addText = S.qs('[data-add-to-cart-text]', form);
    var errorEl = S.qs('[data-product-error]', section);
    var strings = { add: form.getAttribute('data-text-add') || 'Add to cart', soldout: form.getAttribute('data-text-soldout') || 'Sold out', unavailable: form.getAttribute('data-text-unavailable') || 'Unavailable', adding: form.getAttribute('data-text-adding') || 'Adding…', added: form.getAttribute('data-text-added') || 'Added' };

    function selectedOptions() {
      var opts = [];
      S.qsa('[data-option-index]', section).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = S.qs('input:checked', group);
        var sel = S.qs('select', group);
        opts[idx] = checked ? checked.value : (sel ? sel.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
      })[0] || null;
    }
    function updateAvailabilityMarks(opts) {
      if (!product) return;
      S.qsa('[data-option-index]', section).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        S.qsa('input', group).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = product.variants.filter(function (v) { return v.options.every(function (o, i) { return i === idx ? o === test[i] : (test[i] === undefined || o === test[i]); }); });
          var available = match.some(function (v) { return v.available; });
          var label = S.qs('label[for="' + input.id + '"]', group);
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }
    function updateGallery(variant) {
      if (!variant || !variant.featured_media) return;
      var thumb = S.qs('[data-media-id="' + variant.featured_media.id + '"]', section);
      if (thumb) S.gallery && S.gallery.show(section, variant.featured_media.id);
    }
    function render() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateAvailabilityMarks(opts);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addText) addText.textContent = strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = money(variant.compare_at_price); compareEl.hidden = false; if (saleBadge) saleBadge.hidden = false; }
        else { compareEl.hidden = true; if (saleBadge) saleBadge.hidden = true; }
      }
      if (addBtn) { addBtn.disabled = !variant.available; if (addText) addText.textContent = variant.available ? strings.add : strings.soldout; }
      updateGallery(variant);
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
    }
    section.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) render(); });
    render();

    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-cart-type') !== 'drawer') return; // fall back to native submit
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (addText) addText.textContent = strings.adding;
      addBtn.disabled = true;
      var fd = new FormData(form);
      S.cart.add(fd).then(function () {
        if (addText) addText.textContent = strings.added;
        setTimeout(function () { if (addText) addText.textContent = strings.add; addBtn.disabled = false; }, 1400);
        S.openDrawer('CartDrawer');
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        if (addText) addText.textContent = strings.add; addBtn.disabled = false;
      });
    });
  }

  /* ---------- Gallery ---------- */
  S.gallery = {
    show: function (section, mediaId) {
      S.qsa('[data-gallery-slide]', section).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-gallery-slide') === String(mediaId)); });
      S.qsa('[data-media-id]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId)); });
      S.qsa('[data-gallery-dot]', section).forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-gallery-dot') === String(mediaId)); });
    },
    init: function (section) {
      var slides = S.qsa('[data-gallery-slide]', section);
      if (!slides.length) return;
      function current() { var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); }); return i < 0 ? 0 : i; }
      section.addEventListener('click', function (e) {
        var t = e.target.closest('[data-media-id]');
        if (t) { e.preventDefault(); S.gallery.show(section, t.getAttribute('data-media-id')); return; }
        var d = e.target.closest('[data-gallery-dot]');
        if (d) { S.gallery.show(section, d.getAttribute('data-gallery-dot')); return; }
        var n = e.target.closest('[data-gallery-next]'); if (n) { S.gallery.show(section, slides[(current() + 1) % slides.length].getAttribute('data-gallery-slide')); return; }
        var p = e.target.closest('[data-gallery-prev]'); if (p) { S.gallery.show(section, slides[(current() - 1 + slides.length) % slides.length].getAttribute('data-gallery-slide')); }
      });
      var main = S.qs('[data-gallery-main]', section), startX = 0;
      if (main) {
        main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 40) return;
          var i = current(); var next = dx < 0 ? (i + 1) % slides.length : (i - 1 + slides.length) % slides.length;
          S.gallery.show(section, slides[next].getAttribute('data-gallery-slide'));
        }, { passive: true });
      }
    }
  };

  /* ---------- Related products (Product Recommendations API) ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = S.qs('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; el.classList.add('is-loaded'); }
      else { el.closest('.shopify-section').hidden = true; }
      if (S.qsa('[data-animate]', el).length && window.IntersectionObserver) S.qsa('[data-animate]', el).forEach(function (a) { a.classList.add('is-visible'); });
    }).catch(function () {});
  }

  function boot(scope) {
    S.qsa('[data-product-section]', scope).forEach(function (s) { initProduct(s); S.gallery.init(s); });
    S.qsa('[data-recommendations]:not(.is-loaded)', scope).forEach(initRecommendations);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
